import * as React from 'react';

function SvgLockFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={14} height={19} fill="none" viewBox="0 0 14 19" {...props}>
      <path
        fill="#5F59FF"
        d="M12 6.667h-.833V5C11.167 2.7 9.3.833 7 .833A4.168 4.168 0 002.833 5v1.667H2c-.917 0-1.667.75-1.667 1.666v8.334c0 .916.75 1.666 1.667 1.666h10c.917 0 1.667-.75 1.667-1.666V8.333c0-.916-.75-1.666-1.667-1.666zm-5 7.5c-.917 0-1.667-.75-1.667-1.667s.75-1.667 1.667-1.667 1.667.75 1.667 1.667-.75 1.667-1.667 1.667zm-2.5-7.5V5c0-1.383 1.117-2.5 2.5-2.5S9.5 3.617 9.5 5v1.667h-5z"
      />
    </svg>
  );
}

export default SvgLockFilled;
